const userTypes = {
	EMAIL_SIGN_IN_START: 'EMAIL_SIGN_IN_START',
	SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
	FETCH_CUSTOMERS_START: 'FETCH_CUSTOMERS_START',
	SET_CUSTOMERS: 'SET_CUSTOMERS',
	FETCH_VENDORS_START: 'FETCH_VENDORS_START',
	SET_VENDORS: 'SET_VENDORS',
	CHECK_USER_SESSION: 'CHECK_USER_SESSION',
	SIGN_OUT_USER_START: 'SIGN_OUT_USER_START',
	SIGN_OUT_USER_SUCCESS: 'SIGN_OUT_USER_SUCCESS',
	RESET_PASSWORD_START: 'RESET_PASSWORD_START',
	RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
	SIGN_UP_USER_START: 'SIGN_UP_USER_START',
	UPDATE_USER_START: 'UPDATE_USER',
	UPDATE_USER_SUBSCRIPTION: 'UPDATE_USER_SUBSCRIPTION',
	USER_ERROR: 'USER_ERROR',
	RESET_USER_STATE: 'RESET_USER_STATE',
}

export default userTypes;